<template>
  <div :class="['header-wrap', { sticky: isSticky }]">
    <!-- Top Header -->
    <div class="header-top" :class="{ open: open }">
      <button type="button" class="close-sidebar" @click="open = !open">
        <i class="ri-close-fill"></i>
      </button>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8 col-md-9">
            <div class="header-top-left">
              <ul class="contact-info list-style">
                <li>
                  <!-- <i class="flaticon-whatsapp"></i> -->
                  <i class="ri-whatsapp-fill"></i>
                  <a href="https://wa.me/2975942167?text=Hi%2C%20How%20can%20we%20help%20you%3F">+(297) 594-2167</a>
                </li>
                <li>
                  <i class="flaticon-email-1"></i>
                  <a href="mailto:info@total.aw">info@total.aw</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-3">
            <div class="header-top-right">
              <ul class="header-top-menu list-style">
                <li><router-link to="/contact">Contact Us</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Top Header -->

    <!-- Navbar -->
    <div class="header-bottom">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <router-link class="navbar-brand" to="/">
            <img
              class="logo-light"
              width="150"
              src="../../assets/images/NewLogo.png"
              alt="logo" />
            <img
              class="logo-dark"
              src="../../assets/images/NewLogo.png"
              alt="logo" />
          </router-link>

          <div class="collapse navbar-collapse" :class="{ show: active }">
            <ul class="navbar-nav ms-auto">

              <li class="nav-item">
                <router-link to="/" class="nav-link">Home</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/personal-loan" class="nav-link">Personal Loan</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/car-loan" class="nav-link">Car Loan</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/faq" class="nav-link">FAQ</router-link>
              </li>
              
              <li class="nav-item">
                <router-link to="/about" class="nav-link">About us</router-link>
              </li>

            </ul>

            <div class="others-options d-flex align-items-cente">
              <div class="header-btn">
                <router-link :to="{ name: 'HomeOnePage', params: { ToCalculator: true } }" class="btn style1">Apply Now</router-link>
              </div>
            </div>
          </div>

          <div class="mobile-bar-wrap">
            <div
              class="mobile-sidebar"
              @click="open = !open"
              :aria-pressed="open ? 'true' : 'false'"
              v-bind:class="{ open: button_open_state }"
              v-on:click="button_open_state = !button_open_state">
              <i class="ri-menu-4-line"></i>
            </div>
            
            <div
              class="navbar-toggler mobile-menu xl-none"
              @click="active = !active"
              :aria-pressed="active ? 'true' : 'false'"
              v-bind:class="{ active: button_active_state }"
              v-on:click="button_active_state = !button_active_state">
              <a href="javascript:void(0);">
                <i class="ri-menu-line"></i>
                <i class="ri-close-line"></i>
              </a>
            </div>
          </div>
        </nav>
      </div>
      
    </div>
    <!-- End Navbar -->
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data: () => ({
    isSticky: false,
    active: false,
    button_active_state: false,
    search: false,
    button_search_state: false,
    open: false,
    button_open_state: false,
  }),
  mounted() {
    const that = this;
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        that.isSticky = true;
      } else {
        that.isSticky = false;
      }
    });
  },
};
</script>
